import { useDisclosure, MenuItem } from '@chakra-ui/react';
import {
    contactRequiredTypes, Notice, Property, updateRequiredTypes,
} from '@acp/shared';
import { ExternalRegionLinkButton, useAgencySettings } from '@acp/feature/auth';
import { ResolveIssueModal } from '../resolve-issue-modal/resolve-issue-modal';
import { OccupantActions } from '../../../../components/buttons';
import { useActiveNotices } from '../../hooks/use-active-notices';
import { BookingModal } from '../booking-modal/booking-modal';
import { SendNotificationModalButton } from '../send-notification-modal';
import { RequestOneOffENButton } from '../one-off-en/request-modal';

export function ResolveActionButton({
    property,
    notice,
    tenancyId = null,
    hideDropDown = false,
    variant = 'outline',
}: {
    property: Property;
    notice: Notice;
    tenancyId?: number | null;
    variant?: string;
    hideDropDown?: boolean;
}) {
    const resolveModalDisclosure = useDisclosure();
    const bookingModal = useDisclosure();

    const { agencySettings } = useAgencySettings();

    const agencyAllowBookings = agencySettings?.allow_agency_portal_booking;

    const isShowBookButton = agencyAllowBookings === true;

    const { action } = useActiveNotices(notice, {
        propertyId: property.compliancePropertyId,
        address: property.address,
        isIntegrated: property.isIntegrated ?? false,
    });

    let disabledReason = '';

    let { isContactDiRequired } = notice;

    if (contactRequiredTypes.includes(notice.noticeType)) {
        isContactDiRequired = true;
    }

    let actionLink: string | undefined | null;
    if (updateRequiredTypes.includes(notice.noticeType)) {
        actionLink = action.link;

        // for integrated:
        if (property.isIntegrated === true) {
            disabledReason = 'Please update your property management software with latest lease details';
        }
    }

    if (isContactDiRequired) {
        disabledReason = 'Please contact your account manager';
    }

    const onResolveButtonClicked = () => {
        if (actionLink == null) {
            resolveModalDisclosure.onOpen();
        }
    };

    return (
        <>
            <OccupantActions
                as={actionLink != null ? ExternalRegionLinkButton : undefined}
                path={actionLink}
                propertyId={property.compliancePropertyId}
                tenancyId={tenancyId}
                title={isContactDiRequired ? 'Contact us' : action.description ?? 'Resolve issue'}
                isDisabled={disabledReason !== ''}
                disabledReason={disabledReason}
                onClick={onResolveButtonClicked}
                hideDropDown={hideDropDown}
                variant={variant}
            >
                {isShowBookButton && <MenuItem onClick={bookingModal.onOpen}>Book</MenuItem>}
                <RequestOneOffENButton
                    notice={notice}
                />
                <SendNotificationModalButton
                    propertyId={property.compliancePropertyId}
                    noticeId={notice.id}
                />
            </OccupantActions>
            <ResolveIssueModal
                isOpen={resolveModalDisclosure.isOpen}
                propertyId={property.compliancePropertyId}
                noticeId={notice.id}
                onClose={resolveModalDisclosure.onClose}
            />
            {bookingModal.isOpen && (
                <BookingModal
                    isOpen={bookingModal.isOpen}
                    onClose={bookingModal.onClose}
                    propertyId={property.compliancePropertyId}
                />
            )}
        </>
    );
}
